// extracted by mini-css-extract-plugin
export default {"item":"styles_item__8qhU7","label":"styles_label__YlyG5","divider":"styles_divider__EsjXo"};